export default __webpack_public_path__ + "static/media/medical2.e9d9aba1.jpg";